const email = {
  sendEmail: "שלח מייל",
  sendBtn: "שלח",
  sent: "המייל נשלח!",
  to: "אל",
  from: "מאת",
  subject: "נושא",
  template: "תבנית",
  noTemplate: "— ללא תבנית —",
  variables: "משתנים",
  sendFrom: "שלח מ-",
  cancel: "ביטול",
  showCcBcc: "CC/BCC",
  hideCcBcc: "הסתר CC/BCC",
  toPlaceholder: "email@example.com (מופרד בפסיקים)",
  recipientRequired: "נדרש נמען",
  subjectRequired: "נדרש נושא",
  status: "סטטוס",
  sentAt: "נשלח ב-",
  opens: "פתיחות",
  clicks: "קליקים",
  firstOpened: "פתיחה ראשונה",
  clickedLinks: "לינקים שנלחצו",
  htmlPreview: "תצוגת HTML",
  bounceReason: "סיבת חזרה",
  errorMessage: "שגיאה",
  totalSent: "נשלחו",
  opened: "נפתחו",
  clicked: "נלחצו",
  bounced: "חזרו",
  openRate: "אחוז פתיחה",
  clickRate: "אחוז קליקים",
  noEmailsSent: "עדיין לא נשלחו מיילים",
  emails: "מיילים",
} as const;
export default email;
